import { get, has } from 'lodash';
import { farmerNavigationDefaultOperation } from 'constants/operations';
import { resourceType } from 'constants/loading';
import { isResourceUnloaded } from 'loading/selectors';
import { createSelector } from '@reduxjs/toolkit';

export const getAllOperations = (state) => get(state, 'operations');
export const getAllOperationUuids = createSelector([
  (state) => state.operations
],
(operations) => Object.keys(operations)
);
export const getOperationByUuid = (state, operationUuid) => get(getAllOperations(state), operationUuid);
export const selectedOperationIsAll = (state, operationUuid) => {
  return operationUuid === farmerNavigationDefaultOperation;
};
export const userCanAccessOperation = (state, operationUuid) => {
  return has(getAllOperations(state), operationUuid) || selectedOperationIsAll(state, operationUuid);
};
export const areFieldsForOperationLoaded = (state, operationUuid) => isResourceUnloaded({
  state,
  type: resourceType.FIELDS_BY_OPERATION_ID,
  id: operationUuid
});
